<ng-container *rxLet="state$ as state">
  <section data-test-id="user-profile-terms-container" id="terms-agreement">
    <h4 class="font-bold">Terms and conditions</h4>
    @if (!state.termsAndConditionsLoading) {
      @if (state.termsAndConditions) {
        <p>
          You can obtain further information on the personal data which Darize stores and processes about you by contacting
          <a href="mailto:privacy@darize.com">privacy&#64;darize.com</a>
          . Further, you may object to your personal data being processed or request that your personal data is
          rectified or deleted. If you wish to withdraw your consent or have your data rectified or deleted, please
          contact your Darize consultant manager or
          <a href="mailto:privacy@darize.com">privacy&#64;darize.com</a>
          . Further, if you have any complaints about Darize’s processing of your personal data, you may contact the Danish
          Data Protection Agency (
          <a href="https://www.datatilsynet.dk" target="_blank">www.datatilsynet.dk</a>
          ).
        </p>
        <div class="sliders-container">
          <form [formGroup]="termsForm" data-test-id="user-profile-terms-form">
            <div class="slider">
              <h5 class="font-bold">Event invitations</h5>
              <p>
                From time to time Darize sends out invitations for professional and social events and general information
                regarding Darize to you, if you have given your consent to this. You may at any time withdraw your consent
                by either following the unsubscribe link at the bottom of those emails or on your myDarize user profile.
              </p>
              <mat-slide-toggle
                color="accent"
                data-test-id="user-profile-eventInvitation-slider"
                disableRipple="true"
                formControlName="AcceptMy7nEventInvitation"
              >
                I want to receive Darize event invitations and general information.
              </mat-slide-toggle>
            </div>
            <div class="slider">
              <h5 class="font-bold">Newsletter</h5>
              <p>
                Sign up here to receive monthly e-mails about news and information about Darize’s services, products and
                events. You may withdraw your consent to receive newsletters from Darize at any time by following the
                unsubscribe link at the bottom of newsletters or by turning off this option. Read more about Darize’s
                processing of your personal data in Darize’s
                <a href="https://www.darize.com/trust-and-transparency/" target="_blank">Privacy Policy</a>
                .
              </p>
              <mat-slide-toggle
                color="accent"
                data-test-id="user-profile-newsletter-slider"
                disableRipple="true"
                formControlName="AcceptMy7nNewsletter"
              >
                I want to receive Darize newsletters with news, events and service information.
              </mat-slide-toggle>
            </div>
          </form>
        </div>
      } @else {
        <no-data></no-data>
      }
    } @else {
      <div class="flex flex-center-start w-full h-full">
        <loader color="primary"></loader>
      </div>
    }
  </section>
</ng-container>
